<template>
  <h1>Page not found</h1>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
</style>
